"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTO_LABEL = void 0;
exports.generateQualityKey = generateQualityKey;
exports.heightToLabel = heightToLabel;
exports.isHLS = isHLS;
exports.isMP4 = isMP4;
exports.qualitiesRecord = qualitiesRecord;
exports.sortQualities = sortQualities;
exports.sortQualitiesByCodec = sortQualitiesByCodec;
var AUTO_LABEL = exports.AUTO_LABEL = 'Auto';
var HEVC_PREFIX_LABEL = 'hvc1';
var AVC_PREFIX_LABEL = 'avc1';
function generateQualityKey(src, height) {
  return "".concat(src, ":").concat(height);
}
function heightToLabel(height) {
  switch (height) {
    case 2160:
      return '4K';
    case 0:
    case null:
    case undefined:
      return 'Auto';
    default:
      return "".concat(height, "p");
  }
}
function isMP4(src) {
  return /\.mp4/.test(src);
}
function isHLS(src) {
  return /\.m3u8/.test(src);
}
function sortQualities(qualities) {
  return qualities.sort(function (a, b) {
    return a.bitrate < b.bitrate ? 1 : -1;
  });
}
function qualitiesRecord() {
  return {
    "native": {},
    normalised: []
  };
}

// This function is temporary until quality scores for codecs are avalible
function sortQualitiesByCodec(qualities) {
  return qualities.sort(function (a, b) {
    if (a.codecs.startsWith(HEVC_PREFIX_LABEL) && b.codecs.startsWith(AVC_PREFIX_LABEL)) {
      return -1;
    } else if (a.codecs.startsWith(AVC_PREFIX_LABEL) && b.codecs.startsWith(HEVC_PREFIX_LABEL)) {
      return 1;
    }
    return 0;
  });
}